import React from 'react'
import ReactDOM from 'react-dom'

const SearchItem = ({ location, phrase, handleSetCurrentTown }) => {
    const locationArr = [];

    if (location.CITY) locationArr.push(location.CITY)
    if (location.REGION) locationArr.push(location.REGION)

    const locationCity = locationArr.join(', ').replace(new RegExp(phrase, 'gim'), `<strong>${ phrase }</strong>`)

    return <div
        data-id={ location.ID }
        data-name={ location.CITY }
        className="happy-select-location__search-item"
        dangerouslySetInnerHTML={ { __html : locationCity } }
        onClick={ handleSetCurrentTown.bind(this, location.ID, location.CITY) }
    ></div>
}

export default SearchItem